var re = /(margin|border|padding|width|color|background)/i;
export var propsToForward = function (prop) {
    return typeof prop === 'string' && re.test(prop) === false;
};
//# sourceMappingURL=propsToForward.js.map